import { IconTypes } from '@app/ui'

export enum MenuItemType {
    LINK = 'link',
    MODAL = 'modal',
    DIVIDER = 'divider',
    LOGOUT = 'logout',
    SHARE_SOCIAL = 'shareSocial',
    ACTION = 'action',
    DROPDOWN = 'dropdown',
  }

export interface AppMenuProps {
    open: boolean
    onClose: () => void
    positionX?: number
  }

export interface MenuItem {
    title: string
    iconType?: IconTypes
    route?: string
    type: MenuItemType
    disable?: boolean
    hide?: boolean
    action?: () => void | Promise<void>
    topBorder?: boolean
    size?: number
    highlighted?: boolean
    children?: MenuItem[]
  }

export interface MenuItemProps {
    iconType: IconTypes;
    title: string;
    disable?: boolean;
    action: () => void;
  }

export interface MenuState {
    openSocial: boolean
    loading: boolean
    shareLink: string | null
    channelName: string
    openLanguageSelect: boolean
  }